import React from "react";

const columns = [  
  {
    title: 'Attribute Name',
    dataIndex: 'attribute_name',
    key: 'attribute_name',
    width: 300,
  },
  {
    title: 'Attribute Key',
    dataIndex: 'attribute_key',
    key: 'attribute_key',
  },
  {
    title: 'Attribute Type',
    dataIndex: 'attribute_element_type',
    key: 'attribute_key',
    width: 150,
  },
  {
    title: 'Max Value',
    dataIndex: 'max_size',
    key: 'max_size',
    width: 150,
  },
  {
    title: "Last Updated",
    dataIndex: "updated_at",
    width: 200,
    
  },
];
export default columns;
